import * as yup from 'yup';

export const schema = yup.object().shape({
  from: yup.string().nullable().required("Le champ 'from' est obligatoire."),
  to: yup.string().nullable().required("Le champ 'to' est obligatoire."),
});
